<template>
  <div>
      Vous avez bien connecté votre compte.
  </div>

</template>

<script setup>
import google_service from "../services/google.js";

const routeFromGoogle = async () => {
  console.log("Current route: ", window.location.href);
  let queryParams = window.location.href.split("?")[1];
  // check router parameters
  const data =  Object.fromEntries(new URLSearchParams(queryParams));
  console.log("Got data: ", data);
  // send message to window
  if (data.code) {
      console.log("Got code: ", data.code);

      // let res = await google_service.send_token(data.code);

      let res = await google_service.connect(data.code);

      window.close();
  }
  // window.opener.postMessage(data, window.location.origin);
}

// switch case based on window name
switch (window.name) {
  case "googleOAauthWindow":
      routeFromGoogle();
      break;
  default:
      break;
}
</script>